import {
  Box,
  FormControlLabel,
  Grid,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';

import { textFieldDefaultStyle } from '../../../../../components/UI/Typography';

export const PaperQuestion = styled(Paper)(({ theme }) => ({
  backgroundColor: '#FFFFFF',
  border: '1px solid #D7D8DB',
  padding: '40px',
  width: '620px',
  '&.MuiPaper-root': {
    minHeight: '460px',
    minWidth: '300px',
    padding: '40px',
    maxWidth: '100%',
  },
  [theme.breakpoints.up('xl')]: {
    width: '820px',
  },
}));

export const FlexBox = styled(Box)(() => ({
  display: 'flex',
  gap: '10px',
  alignItems: 'center',
}));

export const NumberTypography = styled(Typography)(({ theme }) => ({
  fontSize: '21px',
  fontWeight: '600',
  color: theme.palette.secondary.main,
}));

export const TitleTypography = styled(Typography)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  fontSize: '21px',
  fontWeight: '600',
}));

export const ShortAnswerTextField = styled(TextField)(() => ({
  ...textFieldDefaultStyle,
  width: '100%',
  margin: '8px',
}));

export const FlexCenterGrid = styled(Grid)(() => ({
  display: 'flex',
  alignItems: 'center',
}));

export const SingleSelectTypo = styled(Typography)(() => ({
  marginTop: '-10px',
  fontSize: '14px',
  color: '#8B8C8E',
}));

export const MultiFormControl = styled(FormControlLabel)(({ theme }) => ({
  margin: '8px 0',
  '& .MuiButtonBase-root': {
    padding: '4px',
    color: theme.palette.common.grey,
    '&.Mui-checked': {
      color: theme.palette.common.grey,
    },
  },
  '&:hover': {
    '& .MuiTypography-root': {
      fontWeight: '600',
      fontSize: '18px',
    },
  },
  '& .MuiTypography-root': {
    fontSize: '18px',
  },
}));

export const CheckboxFormControl = styled(FormControlLabel)(({ theme }) => ({
  padding: '8px 12px 0',
  '& .MuiButtonBase-root': {
    padding: '4px',
    color: theme.palette.common.grey,
  },
  '&:hover': {
    '& .MuiTypography-root': {
      fontWeight: '600',
    },
  },
  '& .MuiTypography-root': {
    fontSize: '18px',
  },
}));

export const ListTextField = styled(TextField)(() => ({
  ...textFieldDefaultStyle,
  margin: '40px 20px 16px',
  minWidth: '180px',
  width: 'fit-content',
}));

export const StyledDatePicker = {
  ...textFieldDefaultStyle,
  margin: '24px 6px 16px',
  minWidth: '180px',
};
